import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

const InputBox = styled(Box)(({ theme }) => ({
  marginTop: 0,
  marginBottom: 0,
  // backgroundColor: project.colors[theme.palette.mode].input.backgroundColor,
  // backgroundColor: (theme.palette.mode === 'light') ? '#f5f5f9' : '#393939',
  padding: theme.spacing(0),
  border: `solid 1px ${theme.palette.secondary.dark}`,
  borderRadius: 1,
  // '& > p': {
  //   color: project.colors[theme.palette.mode].input.color,
  // },
}))

export default InputBox
